import { isSancusV4, getTenantConfigFromMeta } from './utils/metaTagUtils';

// get current stage
interface Env {
  stage: string;
  serverEndpoint: string;
  gatewayEndpoint: string;
}

let env: Env | null = null;
let envPromise: Promise<Env> | null = null;

const getEnvFromMeta = (): Env => {
  const decoded = getTenantConfigFromMeta();
  if (!decoded) {
    throw new Error('tenant-config meta tag not found');
  }
  
  return {
    stage: decoded.stageName,
    serverEndpoint: decoded.backendBaseUrl,
    gatewayEndpoint: decoded.backendBaseUrl
  };
};

export const getEnv = async (): Promise<Env> => {
  if (env) {
    return env;
  }

  // Prevent concurrent requests
  if (envPromise) {
    return envPromise;
  }

  // For SANCUS_V4, get config from meta tag
  if (isSancusV4()) {
    envPromise = Promise.resolve(getEnvFromMeta()).then((data: Env) => {
      env = data;
      return data;
    });
    return envPromise;
  }

  // For SANCUS_V3, fetch from settings.json
  envPromise = fetch('/settings.json', {
    credentials: 'same-origin',
  }).then((response) => {
    if (response.status === 200) {
      return response.json();
    }
    throw new Error(`Failed to get environment configuration: ${response.statusText}`);
  }).then((data: Env) => {
    if (data === null) {
      throw new Error('Failed to get environment configuration: env is null');
    }
    env = data;
    return data;
  });

  return envPromise;
};
